import React, { Component } from 'react'
import {connect} from 'react-redux';

import RoomsList from '../rooms/RoomsList';
import ItemsList from '../items/ItemsList';
import IssuesList from '../issues/IssuesList';


import { Grid } from '@material-ui/core';


class SetUpBase extends Component {
    constructor(props){
        super(props);

        this.state = {

        }

    }


    render() {
        return (
                <Grid item container xs={12} justifyContent='space-evenly' style={{paddingTop:'1rem'}}>
                    {/* Rooms */}
                    <Grid item container xs={12} sm={6} md={4} lg={4} >
                        <RoomsList
                            communityId={this.props.communityId}
                        />
                    </Grid>

                    {/* Items */}
                    <Grid item container xs={12} sm={6} md={4} lg={4}>
                        <ItemsList
                            communityId={this.props.communityId}
                        />
                    </Grid>

                    {/* Issues */}
                    <Grid item container xs={12} sm={6} md={4} lg={4}>
                        <IssuesList
                            communityId={this.props.communityId}
                        />
                    </Grid>
                    
                </Grid>
        )
    }
}

function mapStateToProps(state,dispatch) {

    return{

    }
};

export default connect(mapStateToProps,{})(SetUpBase)

